export default [
    {
        date: 1584692993631,
        row: 14,
        col: 13,
        squares: [
            [12, 2, "#666666"],
            [11, 2, "#666666"],
            [10, 2, "#666666"],
            [9, 2, "#666666"],
            [8, 2, "#666666"],
            [7, 2, "#666666"],
            [6, 2, "#666666"],
            [5, 2, "#666666"],
            [5, 1, "#000000"],
            [6, 1, "#434343"],
            [7, 1, "#000000"],
            [8, 1, "#434343"],
            [9, 1, "#000000"],
            [10, 1, "#434343"],
            [11, 1, "#000000"],
            [12, 1, "#434343"],
            [6, 3, "#666666"],
            [6, 4, "#666666"],
            [5, 4, "#666666"],
            [6, 5, "#666666"],
            [6, 6, "#666666"],
            [5, 6, "#666666"],
            [6, 7, "#666666"],
            [6, 8, "#666666"],
            [5, 8, "#666666"],
            [6, 9, "#666666"],
            [5, 10, "#666666"],
            [6, 10, "#666666"],
            [6, 11, "#666666"],
            [6, 12, "#666666"],
            [5, 12, "#666666"],
            [6, 13, "#434343"],
            [4, 12, "#666666"],
            [4, 13, "#434343"],
            [5, 13, "#000000"],
            [7, 13, "#000000"],
            [7, 12, "#666666"],
            [8, 12, "#666666"],
            [8, 13, "#434343"],
            [9, 13, "#000000"],
            [9, 12, "#666666"],
            [10, 12, "#666666"],
            [10, 13, "#434343"],
            [11, 13, "#000000"],
            [11, 12, "#666666"],
            [12, 12, "#666666"],
            [12, 13, "#434343"],
            [4, 2, "#666666"],
            [4, 1, "#434343"],
            [1, 1, "#434343"],
            [2, 1, "#9900FF"],
            [1, 2, "#000000"],
            [12, 9, "#A61C00"],
            [11, 9, "#A61C00"],
            [10, 9, "#A61C00"],
            [9, 9, "#A61C00"],
            [8, 8, "#A61C00"],
            [8, 7, "#A61C00"],
            [8, 6, "#A61C00"],
            [9, 5, "#A61C00"],
            [10, 5, "#A61C00"],
            [11, 5, "#A61C00"],
            [12, 5, "#A61C00"],
            [9, 6, "#A61C00"],
            [9, 7, "#A61C00"],
            [9, 8, "#A61C00"],
            [10, 8, "#A61C00"],
            [11, 8, "#A61C00"],
            [12, 8, "#A61C00"],
            [12, 7, "#A61C00"],
            [11, 7, "#A61C00"],
            [10, 7, "#A61C00"],
            [10, 6, "#A61C00"],
            [11, 6, "#A61C00"],
            [12, 6, "#A61C00"],
            [7, 3, "#666666"],
            [8, 3, "#666666"],
            [10, 3, "#666666"],
            [9, 3, "#666666"],
            [11, 3, "#666666"],
            [12, 3, "#666666"],
            [12, 4, "#666666"],
            [11, 4, "#666666"],
            [10, 4, "#666666"],
            [9, 4, "#666666"],
            [8, 4, "#666666"],
            [8, 5, "#666666"],
            [7, 5, "#666666"],
            [7, 4, "#666666"],
            [7, 6, "#666666"],
            [7, 7, "#666666"],
            [7, 8, "#666666"],
            [7, 9, "#666666"],
            [8, 9, "#666666"],
            [7, 10, "#666666"],
            [8, 10, "#666666"],
            [9, 10, "#666666"],
            [10, 10, "#666666"],
            [11, 10, "#666666"],
            [12, 10, "#666666"],
            [12, 11, "#666666"],
            [10, 11, "#666666"],
            [11, 11, "#666666"],
            [9, 11, "#666666"],
            [8, 11, "#666666"],
            [7, 11, "#666666"],
            [5, 3, "#00FFFF"],
            [4, 3, "#00FFFF"],
            [4, 4, "#00FFFF"],
            [4, 5, "#00FFFF"],
            [5, 5, "#00FFFF"],
            [4, 6, "#00FFFF"],
            [4, 7, "#00FFFF"],
            [5, 7, "#00FFFF"],
            [4, 8, "#00FFFF"],
            [4, 9, "#00FFFF"],
            [5, 9, "#00FFFF"],
            [4, 10, "#00FFFF"],
            [4, 11, "#00FFFF"],
            [5, 11, "#00FFFF"],
            [3, 13, "#000000"],
            [3, 12, "#00FFFF"],
            [3, 11, "#00FFFF"],
            [3, 10, "#00FFFF"],
            [3, 8, "#FFFF00"],
            [3, 9, "#00FFFF"],
            [3, 7, "#00FFFF"],
            [3, 6, "#00FFFF"],
            [3, 3, "#00FFFF"],
            [3, 4, "#00FFFF"],
            [3, 5, "#00FFFF"],
            [3, 1, "#000000"],
            [3, 2, "#00FFFF"],
            [2, 2, "#00FFFF"],
            [2, 3, "#00FFFF"],
            [1, 3, "#434343"],
            [1, 4, "#000000"],
            [2, 4, "#00FFFF"],
            [2, 5, "#00FFFF"],
            [1, 5, "#434343"],
            [1, 6, "#9900FF"],
            [2, 6, "#00FFFF"],
            [2, 7, "#FFFF00"],
            [1, 7, "#434343"],
            [1, 8, "#9900FF"],
            [2, 8, "#FFFF00"],
            [1, 9, "#434343"],
            [2, 9, "#FFFF00"],
            [1, 10, "#000000"],
            [2, 10, "#00FFFF"],
            [2, 11, "#00FFFF"],
            [1, 11, "#434343"],
            [1, 12, "#000000"],
            [2, 12, "#00FFFF"],
            [2, 13, "#9900FF"],
            [1, 13, "#434343"],
            [13, 1, "#000000"],
            [13, 2, "#980000"],
            [13, 3, "#980000"],
            [13, 4, "#980000"],
            [13, 5, "#980000"],
            [13, 6, "#980000"],
            [13, 7, "#980000"],
            [13, 8, "#980000"],
            [13, 9, "#980000"],
            [13, 11, "#980000"],
            [13, 10, "#980000"],
            [13, 12, "#980000"],
            [13, 13, "#000000"],
            [14, 13, "#434343"],
            [14, 12, "#000000"],
            [14, 11, "#434343"],
            [14, 10, "#000000"],
            [14, 9, "#434343"],
            [14, 8, "#9900FF"],
            [14, 7, "#434343"],
            [14, 6, "#9900FF"],
            [14, 5, "#434343"],
            [14, 3, "#434343"],
            [14, 4, "#000000"],
            [14, 2, "#000000"],
            [14, 1, "#434343"],
        ],
    },
    {
        date: 1494942072804,
        row: 14,
        col: 13,
        squares: [
            [2, 1, "#FF0000"],
            [1, 1, "#FF0000"],
            [1, 2, "#FF0000"],
            [13, 13, "#FF0000"],
            [14, 13, "#FF0000"],
            [14, 12, "#FF0000"],
            [1, 12, "#FF0000"],
            [1, 13, "#FF0000"],
            [2, 13, "#FF0000"],
            [13, 1, "#FF0000"],
            [14, 1, "#FF0000"],
            [14, 2, "#FF0000"],
            [13, 2, "#000000"],
            [12, 2, "#000000"],
            [13, 3, "#000000"],
            [2, 11, "#000000"],
            [2, 12, "#000000"],
            [3, 12, "#000000"],
            [13, 12, "#000000"],
            [12, 12, "#000000"],
            [13, 11, "#000000"],
            [2, 2, "#000000"],
            [3, 2, "#000000"],
            [2, 3, "#000000"],
            [3, 4, "#00FFFF"],
            [3, 3, "#00FFFF"],
            [4, 3, "#00FFFF"],
            [3, 10, "#00FFFF"],
            [3, 11, "#00FFFF"],
            [4, 11, "#00FFFF"],
            [11, 11, "#00FFFF"],
            [12, 11, "#00FFFF"],
            [12, 10, "#00FFFF"],
            [11, 3, "#00FFFF"],
            [12, 3, "#00FFFF"],
            [12, 4, "#00FFFF"],
            [4, 9, "#00FF00"],
            [4, 10, "#00FF00"],
            [5, 10, "#00FF00"],
            [10, 10, "#00FF00"],
            [11, 10, "#00FF00"],
            [11, 9, "#00FF00"],
            [11, 5, "#00FF00"],
            [11, 4, "#00FF00"],
            [10, 4, "#00FF00"],
            [5, 4, "#00FF00"],
            [4, 4, "#00FF00"],
            [4, 5, "#00FF00"],
            [5, 8, "#FF00FF"],
            [5, 9, "#FF00FF"],
            [6, 9, "#FF00FF"],
            [9, 9, "#FF00FF"],
            [10, 9, "#FF00FF"],
            [10, 8, "#FF00FF"],
            [10, 6, "#FF00FF"],
            [10, 5, "#FF00FF"],
            [9, 5, "#FF00FF"],
            [5, 5, "#FF00FF"],
            [5, 6, "#FF00FF"],
            [6, 5, "#FF00FF"],
            [6, 6, "#FF9900"],
            [7, 6, "#FF9900"],
            [6, 7, "#FF9900"],
            [6, 8, "#FF9900"],
            [7, 8, "#FF9900"],
            [9, 8, "#FF9900"],
            [8, 8, "#FF9900"],
            [9, 7, "#FF9900"],
            [9, 6, "#FF9900"],
            [8, 6, "#FF9900"],
            [7, 7, "#0000FF"],
            [8, 7, "#0000FF"],
            [4, 6, "#9900FF"],
            [5, 7, "#9900FF"],
            [4, 8, "#9900FF"],
            [11, 6, "#9900FF"],
            [10, 7, "#9900FF"],
            [11, 8, "#9900FF"],
            [6, 10, "#434343"],
            [7, 9, "#434343"],
            [8, 9, "#434343"],
            [9, 10, "#434343"],
            [6, 4, "#434343"],
            [7, 5, "#434343"],
            [8, 5, "#434343"],
            [9, 4, "#434343"],
            [3, 6, "#434343"],
            [4, 7, "#434343"],
            [3, 8, "#434343"],
            [11, 7, "#434343"],
            [12, 6, "#434343"],
            [12, 8, "#434343"],
            [7, 4, "#9900FF"],
            [8, 4, "#9900FF"],
            [6, 3, "#9900FF"],
            [9, 3, "#9900FF"],
            [6, 11, "#9900FF"],
            [7, 10, "#9900FF"],
            [8, 10, "#9900FF"],
            [9, 11, "#9900FF"],
            [2, 6, "#980000"],
            [3, 7, "#980000"],
            [2, 8, "#980000"],
            [13, 6, "#980000"],
            [12, 7, "#980000"],
            [13, 8, "#980000"],
            [6, 12, "#5CB85C"],
            [7, 11, "#5CB85C"],
            [8, 11, "#5CB85C"],
            [9, 12, "#5CB85C"],
            [6, 2, "#5CB85C"],
            [7, 3, "#5CB85C"],
            [8, 3, "#5CB85C"],
            [9, 2, "#5CB85C"],
            [1, 6, "#5CB85C"],
            [2, 7, "#5CB85C"],
            [1, 8, "#5CB85C"],
            [13, 7, "#5CB85C"],
            [14, 6, "#5CB85C"],
            [14, 8, "#5CB85C"],
            [1, 7, "#CCCCCC"],
            [14, 7, "#CCCCCC"],
            [6, 13, "#D9D9D9"],
            [7, 12, "#D9D9D9"],
            [8, 12, "#D9D9D9"],
            [9, 13, "#D9D9D9"],
            [6, 1, "#D9D9D9"],
            [7, 2, "#D9D9D9"],
            [8, 2, "#D9D9D9"],
            [9, 1, "#D9D9D9"],
            [7, 13, "#4A86E8"],
            [8, 13, "#4A86E8"],
            [7, 1, "#4A86E8"],
            [8, 1, "#4A86E8"],
            [1, 11, "#00FF00"],
            [1, 10, "#00FF00"],
            [2, 10, "#00FF00"],
            [3, 13, "#00FF00"],
            [4, 13, "#00FF00"],
            [4, 12, "#00FF00"],
            [1, 3, "#00FF00"],
            [1, 4, "#00FF00"],
            [2, 4, "#00FF00"],
            [3, 1, "#00FF00"],
            [4, 1, "#00FF00"],
            [4, 2, "#00FF00"],
            [12, 1, "#00FF00"],
            [11, 1, "#00FF00"],
            [11, 2, "#00FF00"],
            [14, 4, "#00FF00"],
            [14, 3, "#00FF00"],
            [13, 4, "#00FF00"],
            [13, 10, "#00FF00"],
            [14, 10, "#00FF00"],
            [14, 11, "#00FF00"],
            [11, 12, "#00FF00"],
            [11, 13, "#00FF00"],
            [12, 13, "#00FF00"],
            [10, 11, "#000000"],
            [10, 12, "#000000"],
            [10, 13, "#000000"],
            [12, 9, "#FFFF00"],
            [13, 9, "#FFFF00"],
            [14, 9, "#FFFF00"],
            [12, 5, "#FFFF00"],
            [14, 5, "#FFFF00"],
            [13, 5, "#FFFF00"],
            [10, 3, "#FF00FF"],
            [10, 2, "#FF00FF"],
            [10, 1, "#FF00FF"],
            [5, 1, "#000000"],
            [5, 2, "#000000"],
            [5, 3, "#000000"],
            [1, 5, "#FFFF00"],
            [2, 5, "#FFFF00"],
            [3, 5, "#FFFF00"],
            [1, 9, "#FFFF00"],
            [2, 9, "#FFFF00"],
            [3, 9, "#FFFF00"],
            [5, 11, "#FF00FF"],
            [5, 12, "#FF00FF"],
            [5, 13, "#FF00FF"],
        ],
    },
];
